import { Ajax2 } from '@shared/Ajax';


export interface IEquipmentAssignment {
    uuid: string;
    name: string;
    documents: string[];
    equipment: string[];
}

export const EquipmentAssignmentsService = {
    fetch: (equipmentUuid?: string, page?: number, pageSize?: number) => {
        if (equipmentUuid) {
            return Ajax2({
                url: kuura.getContextPath() + `/api/1/equipment/${equipmentUuid}/assignments`,
                data: {
                    projectUuid: kuura.getProjectUuid()
                }
            });
        } else {
            return Ajax2({
                url: kuura.getContextPath() + `/api/1/assignments`,
                data: {
                    projectUuid: kuura.getProjectUuid(),
                    page,
                    pageSize
                }
            }).then(resp => {
                return resp.content ?? [];
            });
        }
    },

    fetchPaginated: (page?: number, pageSize?: number, equipmentUuid?: string) => {
        return Ajax2({
                url: kuura.getContextPath() + `/api/1/assignments`,
                data: {
                    projectUuid: kuura.getProjectUuid(),
                    page,
                    pageSize,
                    equipmentUuid
                }
            });
    },

    create: (name: string) => {
        return Ajax2({
            url: kuura.getContextPath() + `/api/1/assignments`,
            method: 'POST',
            contentType: 'json',
            data: {
                name,
                projectUuid: kuura.getProjectUuid(),
                user: {
                    uuid: kuura.getUserUuid()
                }
            }
        });
    },

    updateName: (uuid: string, name: string) => {
        return Ajax2({
            url: kuura.getContextPath() + `/api/1/assignment/` + uuid,
            method: 'PUT',
            contentType: 'json',
            data: {
                name,
                projectUuid: kuura.getProjectUuid()
            }
        });
    },

    remove: (uuid: string) => {
        return Ajax2({
            url: kuura.getContextPath() + `/api/1/assignment/` + uuid,
            method: 'DELETE'
        });
    },

    addModelsToAssignment: (assUuid: string, modelUuids: string[]) => {
        return Ajax2({
            url: kuura.getContextPath() + `/api/1/assignment/` + assUuid + '/models',
            method: 'POST',
            contentType: 'json',
            data: Array.from(new Set(modelUuids))
        });
    },

    removeModelsFromAssignment: (assUuid: string, modelUuids: string[]) => {
        return Ajax2({
            url: kuura.getContextPath() + `/api/1/assignment/` + assUuid + '/models',
            method: 'DELETE',
            contentType: 'json',
            data: Array.from(new Set(modelUuids))
        });
    },

    addEquipmentToAssignment: (assUuid: string, equipmentUuids: string[]) => {
        return Ajax2({
            url: kuura.getContextPath() + `/api/1/assignment/` + assUuid + '/equipment',
            method: 'POST',
            contentType: 'json',
            data: equipmentUuids
        });
    },

    removeEquipmentFromAssignment: (assUuid: string, equipmentUuids: string[]) => {
        return Ajax2({
            url: kuura.getContextPath() + `/api/1/assignment/` + assUuid + '/equipment',
            method: 'DELETE',
            contentType: 'json',
            data: equipmentUuids
        });
    },

    saveFullAssignments: async (assignmentUuid: string, oldModelUuids: string[], newModelUuids: string[]) => {
        const toAdd = newModelUuids.filter(u => !oldModelUuids.includes(u));
        const toRemove = oldModelUuids.filter(u => !newModelUuids.includes(u));

        if (toAdd.length) {
            await EquipmentAssignmentsService.addModelsToAssignment(assignmentUuid, toAdd);
        }
        if (toRemove.length) {
            await EquipmentAssignmentsService.removeModelsFromAssignment(assignmentUuid, toRemove);
        }
    },

    saveFullEquipment: async (assignmentUuid: string, oldUuids: string[], newUuids: string[]) => {
        const toAdd = newUuids.filter(u => !oldUuids.includes(u));
        const toRemove = oldUuids.filter(u => !newUuids.includes(u));

        if (toAdd.length) {
            await EquipmentAssignmentsService.addEquipmentToAssignment(assignmentUuid, toAdd);
        }
        if (toRemove.length) {
            await EquipmentAssignmentsService.removeEquipmentFromAssignment(assignmentUuid, toRemove);
        }
    }
};
